import { colors } from "material-ui";

const styles = (theme) => ({
  paper: theme.mixins.gutters({
    paddingTop: 0,
    paddingBottom: 0,
    marginBottom: 25,
    paddingLeft: "0!important",
  }),
  removeMargin: {
    marginLeft: 0,
  },
  jobsHeader: {
    backgroundColor: "#005795",
    flexBasis: "calc(66.666667% - 50px)!important",
    maxWidth: "calc(66.666667% - 50px)!important",
    padding: "15px!important",
    paddingBottom: "0!important",
    "& h2": {
      color: "white",
      fontSize: "1.65rem",
      fontWeight: 300,
      letterSpacing: "0.5px",
      marginBottom: "5px",
      display: "inline-block",
      //textOverflow: "ellipsis",
      position: "relative",
      maxWidth: "100%",
      whiteSpace: "normal",
      overflow: "visible",
      lineHeight: 1.2,
    },
    "& h3": {
      color: "white",
      fontSize: "1.05rem",
      fontWeight: 300,
      //textOverflow: "ellipsis",
      position: "relative",
      maxWidth: "100%",
      whiteSpace: "normal",
      overflow: "visible",
      lineHeight: 1.2,
    },
  },
  jobTotals: {
    paddingTop: 25,
    "& div": {
      padding: "0!important",
    },
  },
  jobDate: {
    display: "inline-block",
    float: "right",
  },
  jobCustomer: {
    maxWidth: "100%",
    overflowX: "visible",
    marginRight: 10,
  },
  innerjobDetails: {
    display: "flex",
    justifyContent: "space-between",
  },
  smartFlagProfileRow: {
    alignItems: "center",
    display: "flex",
    marginTop: 8,
    minHeight: 24,
  },
  smartFlagProfileLabel: {
    color: "white",
    flex: "0 0 auto",
    marginRight: 6,
    whiteSpace: "nowrap",
  },
  smartFlagProfileSelectControl: {
    flex: "0 1 auto",
    minWidth: 100,
    maxWidth: 520,
  },
  smartFlagProfileSelect: {
    color: "white",
    fontSize: 12,
    lineHeight: "22px",
    maxWidth: 520,
    position: "relative",
    width: "100%",
  },
  smartFlagProfileSelectDisplay: {
    alignItems: "center",
    boxSizing: "border-box",
    cursor: "pointer",
    display: "flex",
    height: 22,
    lineHeight: "22px",
    minWidth: 100,
    paddingBottom: "0 !important",
    paddingRight: "24px !important",
    paddingTop: "0 !important",
  },
  smartFlagProfileSelectIcon: {
    color: "white",
    height: 22,
    pointerEvents: "none",
    right: 2,
    top: 0,
  },
  smartFlagProfileSelectInput: {
    color: "white",
    height: 22,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    "&:before": {
      borderBottomColor: "rgba(255,255,255,0.55)",
    },
    "&:hover:before": {
      borderBottomColor: "white",
    },
    "& svg": {
      color: "white",
    },
  },
  smartFlagProfileActions: {
    alignItems: "center",
    display: "flex",
    flex: "0 0 auto",
  },
  smartFlagProfileIcon: {
    color: "white",
    fontSize: 16,
    marginRight: 6,
    position: "relative",
    top: 1,
  },
  smartFlagProfileButton: {
    minWidth: "initial",
    padding: "0 6px",
    marginLeft: 6,
    "& span": {
      color: "#FFFFFF",
      fontSize: 22,
    },
  },
  smartFlagProfileButtonDisabled: {
    opacity: 0.45,
  },
  totalGrid: {
    borderRight: "1px solid grey",
    "& p": {
      fontSize: "0.8rem",
      letterSpacing: "1.2px",
      marginBottom: -10,
    },
    "& h1": {
      fontSize: "2.5rem",
      marginBottom: 0,
    },
  },
  passedGrid: {
    borderRight: "1px solid grey",
    "& p": {
      fontSize: "0.8rem",
      letterSpacing: "1.2px",
      marginBottom: -10,
    },
    "& h1": {
      fontSize: "2.5rem",
      marginBottom: 0,
    },
  },
  failedGrid: {
    "& p": {
      fontSize: "0.8rem",
      letterSpacing: "1.2px",
      marginBottom: -10,
    },
    "& h1": {
      fontSize: "2.5rem",
      marginBottom: 0,
    },
  },
  selectedGrid: {
    borderLeft: "1px solid #FF5252",
    "& p": {
      fontSize: "0.8rem",
      letterSpacing: "1.2px",
      marginBottom: -10,
    },
    "& h1": {
      fontSize: "2.5rem",
      marginBottom: 0,
    },
  },
  totalText: {
    color: "grey",
  },
  passedText: {
    color: "#4CAF50",
  },
  failedText: {
    color: "#FF5252",
  },
  selectedText: {
    color: "black",
  },
  jobCardRight: {
    position: "relative",
  },
  viewJob: {
    backgroundColor: theme.palette.accent,
    color: "white",
    position: "absolute",
    bottom: 45,
    right: 15,
    "&:hover": {
      backgroundColor: "#fd5622",
    },
  },
  jobcardButtons: {
    padding: "0 15px",
    minWidth: "initial",
    "& span": {
      color: "white",
      fontSize: 15,
    },
  },
  progressBar: {
    marginBottom: "15px",
  },
  jobFunctions: {
    background: "#1F2532",
    marginLeft: "-15px",
    marginRight: "-15px",
    marginTop: 15,
    bottom: "-10px",
    alignItems: "flex-end",
    borderTop: "grey 1px solid",
  },
  jobCardRight: {
    flexBasis: "calc(33.333333% + 50px)!important",
    maxWidth: "calc(33.333333% + 50px)!important",
    "& a": {
      width: "100%",
    },
  },
  syncButton: {
    display: "inline-block",
    marginLeft: "5%",
    "& span": {
      color: "white!important",
      fontSize: 12,
      fontWeight: 300,
    },
  },
  toggle: {},
  toggleBar: {
    backgroundColor: "grey",
  },
  toggleOn: {
    "& + $toggleBar": {
      backgroundColor: "#36d036",
    },
  },
  jobHeaderDetails: {
    width: "100%",
  },
  attachmentExists: {
    backgroundColor: "#FF7043",
    marginTop: 1,
    "&:hover": {
      backgroundColor: "#FF7043",
    },
  },
  jobStatus: {
    fontSize: "0.8rem",
    color: "#1F2532",
    fontWeight: 700,
  },
  reloadButton: {
    padding: 0,
    minWidth: "initial",
    width: "5%",
    marginLeft: 20,
    "& span": {
      color: "white",
      fontSize: 16,
    },
    "&:hover": {
      backgroundColor: "#1F2532",
    },
    backgroundColor: "#1F2532",
    minHeight: "24px !important",
  },
  exportIcon: {
    display: "inline !important",
  },
  exportProgress: {
    color: "white",
    display: "block",
  },
});

export default styles;
